import React from 'react';
import './ToastMessage.scss';
import Close from "../../../assets/image/Mask.png";
import Success from "../../../assets/image/success_icon.png";

export const SuccessMessage = ({ close, message, timeout = 3000, position = 'bottom' }) => {
  setTimeout(close, timeout);
  return (
    <div className={`info-success-buy info-success-buy--${position}`}>
      <div>
        <span>
          <img src={Success} alt="Success" />
        </span>
        {message}
      </div>
      <span onClick={close} className="close">
        <img src={Close} alt="Close" />
      </span>
    </div>
  );
};